import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchError, tap } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { NEVER } from 'rxjs';
import { FolderService } from '../../services/folder.service';
import { StringHelperService } from '../../../../services/string-helper.service';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { MatFormField, MatInput } from '@angular/material/input';
import { MatLabel } from '@angular/material/form-field';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-folder-edit',
  templateUrl: './folder-edit.component.html',
  styleUrls: ['./folder-edit.component.scss'],
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatButton,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions
  ],
  standalone: true
})
export class FolderEditComponent {
  formGroup = new FormGroup({
    name: new FormControl('', Validators.required)
  });

  constructor(
    private folderService: FolderService,
    private snackBar: MatSnackBar,
    private stringHelperService: StringHelperService,
    private dialogRef: MatDialogRef<FolderEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { id: number }
  ) {}

  change() {
    if (this.formGroup.invalid) {
      this.formGroup.markAllAsTouched();
      this.snackBar.open('Please select all required fields', 'x');
      return;
    }

    if (this.stringHelperService.notAllowedSpecialChars(this.formGroup.get('name')?.value || '')) {
      this.snackBar.open('Folder name cannot contain some special characters. Please rename the folder.', 'x');
      return;
    }
    this.editFolder();
  }

  clear() {
    this.formGroup.reset();
  }

  private editFolder() {
    this.folderService
      .edit(this.data.id, this.formGroup.getRawValue() as unknown as { name: string })
      .pipe(
        tap(folder => {
          this.dialogRef.close(folder);
          this.snackBar.open('The folder was updated successfully', 'x', { panelClass: 'snackbar-green' });
        }),
        catchError((error: HttpErrorResponse) => {
          if (error.status === 409) {
            this.snackBar.open('This folder already exists', 'x');
          } else {
            this.snackBar.open('There was an error. Please try again.', 'x');
          }
          console.error(error);
          return NEVER;
        })
      )
      .subscribe();
  }
}
